/* eslint-disable max-len */
import React from 'react';

export const Services: React.FC = () => (
    <svg
        width="360"
        height="220"
        viewBox="0 0 360 220"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g filter="url(#filter0_d_1384:43)">
            <g clipPath="url(#clip0_1384:43)">
                <rect x="40" y="40" width="260" height="120" rx="16" />
                <g opacity="0.3">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M240 98.0588V89.8235H204.122L179.506 74.4381C183.715 71.4514 186.471 66.5429 186.471 61C186.471 53.3393 181.214 46.8836 174.118 45.0504V36.2941H179.941L195.299 20.9356L185.321 -9H154.679L144.701 20.9356L160.059 36.2941H165.882V52.7647H170C174.541 52.7647 178.235 56.4591 178.235 61C178.235 65.5409 174.541 69.2353 170 69.2353C165.459 69.2353 161.765 65.5409 161.765 61H153.529C153.529 66.5429 156.285 71.4514 160.495 74.4381L135.878 89.8235H100V98.0588H108.235V122.765H100V131H240V122.765H231.765V98.0588H240ZM154.123 18.7115L160.615 -0.764706H179.385L185.877 18.7115L176.53 28.0588H163.47L154.123 18.7115ZM170 78.2087L188.583 89.8235H151.417L170 78.2087ZM116.471 122.765V98.0588H223.529V122.765H116.471ZM132.941 106.294H124.706V114.529H132.941V106.294ZM145.294 106.294H153.529V114.529H145.294V106.294ZM165.882 106.294H174.117V114.529H165.882V106.294ZM194.706 106.294H186.471V114.529H194.706V106.294ZM207.059 106.294H215.294V114.529H207.059V106.294ZM174.117 11.5883H165.882V19.8236H174.117V11.5883Z"
                        fill="#BB6BD9"
                    />
                </g>
            </g>
        </g>
        <defs>
            <filter
                id="filter0_d_1384:43"
                x="0"
                y="0"
                width="360"
                height="220"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="10" dy="10" />
                <feGaussianBlur stdDeviation="25" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.560784 0 0 0 0 0.823529 0 0 0 0 0.952941 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_1384:43"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_1384:43"
                    result="shape"
                />
            </filter>
            <clipPath id="clip0_1384:43">
                <rect x="40" y="40" width="260" height="120" rx="16" />
            </clipPath>
        </defs>
    </svg>
);
